import api from './api';

const shopOrderService = {
    getShopOrders: async () => (await api.get('/admin/shop-orders')).data,
};

export default shopOrderService;
